import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import BrandBlogPage from './BrandBlogPage';

export default function BlogPage() {
  return (
    <>
      <Navbar />
      <BrandBlogPage
        publisher="山頂視角"
        brandName="山頂視角"
        englishName="PEAKVIEW"
        tagline="從政治、商業與人文，拓展看世界的視角"
      />
      <Footer />
    </>
  );
}

